import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';
import { CoursInfo, CoursItem, CoursText, Flex, MyRating, CoursInfoItem, AuthorInfo, Btndate, FreeBtn } from './style';

export default function Cours(props) {
    const [value, setValue] = useState(2);
    return (
        <ScrollAnimation animateIn="animate__zoomIn">
            <CoursItem>
                <img src={props.image} />
                <CoursText>
                    <Link to="/singleCourse">{props.title}</Link>
                    <p>
                        Lorem ipsum dolor sit amet, conse ctetur adi pisicin g elit.
                        Doloribus repel lendus, pariatur qui provident repel lendus!
                    </p>
                    <CoursInfo>
                        <MyRating
                            name={props.name}
                            value={value}
                            precision={0.5}
                            onChange={(event, newValue) => {
                                setValue(newValue);
                            }}
                        />
                        <Flex>
                            <CoursInfoItem>
                                <i className="fas fa-user"></i> <span>20</span>
                            </CoursInfoItem>
                            <CoursInfoItem>
                                <i className="fas fa-heart"></i> <span>20</span>
                            </CoursInfoItem>
                        </Flex>
                    </CoursInfo>
                </CoursText>
                <hr />
                <AuthorInfo>
                    <div>
                        <img src={"/images/bg4.jpg"} />
                        <span>Alan Jhone</span>
                    </div>
                    <Btndate>
                        <p>20 dec 2021</p>
                        <FreeBtn>Free</FreeBtn>
                    </Btndate>
                </AuthorInfo>
            </CoursItem>
        </ScrollAnimation>
    )
}
